module.exports = "https://secnetweb.ksyun.com/KEC/ksc-node-kvm/assets/iconfont.756a07a56a2708ea8deab1d7f4107b59.svg";